<template>
  <el-container style="height: 100%;">
    <el-aside width="360px" style="background-color: #e4e6ecd6;position: relative;">
      <div class="headTitle">
        <div class="headItem" :class="{'is-active': index === activeIndex}" v-for="(item, index) in tabs" :key="index" @click="activeTabs(item)">{{item}}
        </div>
      </div>
      <div class="box" style="position:absolute;left:0;right:0;bottom:0;top:37px;overflow-y:auto">
        <div class="leftCon">
          <div class="formWrapper">
            <el-form
              ref="diagnoseForm" :model="diagnoseForm"
              size="mini"
              label-width="68px"
              label-position="left"
            >
              <el-form-item label="姓名" prop="name">
                <el-input v-model="diagnoseForm.name" style="width: 236px;" placeholder="请输入姓名"></el-input>
              </el-form-item>
              <el-form-item label="性别">
                <el-radio-group
                  v-model="diagnoseForm.gender"
                  size="mini"
                  style="height:28px;"
                >
                  <el-radio-button label="男"></el-radio-button>
                  <el-radio-button label="女"></el-radio-button>
                </el-radio-group>
              </el-form-item>

              <el-form
                size="mini"
                :inline="true"
                style="width:100%;"
              >
                <span class="title" style="display: inline-block;font-size:14px;color: #606266;width:68px;height: 28px;line-height: 28px;">年龄</span>
                <el-form-item style="width:35%;">
                  <el-input v-model="diagnoseForm.age_start" placeholder="从" maxlength="3"></el-input>
                </el-form-item>
                <el-form-item style="width:35%;margin-right: 0;">
                  <el-input v-model="diagnoseForm.age_end" placeholder="到" maxlength="3"></el-input>
                </el-form-item>
              </el-form>

              <el-form-item label="原发部位" prop="primary_site">
                <el-input v-model="diagnoseForm.primary_site" style="width: 236px;" placeholder="请输入原发部位"></el-input>
              </el-form-item>

              <el-form
                size="mini"
                :inline="true"
                style="width:100%;"
              >
                <span class="title" style="display: inline-block;font-size:14px;color: #606266;width:68px;height: 28px;line-height: 28px;">接诊日期</span>
                <el-form-item style="width:35%;">
                  <el-date-picker
                    v-model="diagnoseForm.visit_date_start"
                    align="right"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="从"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item style="width:35%;margin-right: 0;">
                  <el-date-picker
                    v-model="diagnoseForm.visit_date_end"
                    align="right"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="到"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-form>

              <el-form-item label="基线数据">
                <el-select style="width: 236px;"
                  placeholder="请选择"
                  v-model="diagnoseForm.baseline"
                  class="popInput"
                  clearable
                >
                  <el-option label="基线" :value="1"></el-option>
                  <el-option label="非基线" :value="0"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="临床分期" prop="ajcc8_clinical_stage">
                <el-input v-model="diagnoseForm.ajcc8_clinical_stage" style="width: 236px;" placeholder="请输入临床分期"></el-input>
              </el-form-item>

              <el-form-item label="备注" prop="note1">
                <el-input v-model="diagnoseForm.note1" style="width: 236px;" placeholder="请输入备注"></el-input>
              </el-form-item>

              <el-form-item style="margin-bottom: 31px;">
                <div class="moreWrapper" v-show="showMore" style="width: 94%">
                  <div class="show-more-text" @click="showMoreEvent">更多</div>
                  <div class="iconfont show-more-btn" @click="showMoreEvent">&#xe7fe;</div>
                </div>
              </el-form-item>

              <el-form-item label="编号" v-show="!showMore" prop="serial_number">
                <el-input v-model="diagnoseForm.serial_number" style="width: 236px;" placeholder="请输入编号"></el-input>
              </el-form-item>

              <el-form-item v-show="!showMore" label="创建时间">
                <el-date-picker
                  style="width: 236px"
                  v-model="dateRange"
                  type="daterange"
                  range-separator="至"
                  value-format="yyyy-MM-dd"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>

              <el-form-item v-show="!showMore" label="民族">
                <el-select
                  v-model="diagnoseForm.race"
                  placeholder="民族"
                  size="mini"
                  style="width:80px;"
                >
                  <el-option
                    v-for="item in races"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-show="!showMore" label="肤色" prop="skin_color">
                <el-select
                  v-model="diagnoseForm.skin_color"
                  placeholder="选择肤色"
                  size="mini"
                  style="width:236px"
                >
                  <el-option
                    v-for="item in skinOps"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item v-show="!showMore" label="电话" prop="phone">
                <el-input v-model="diagnoseForm.phone" style="width: 236px;"
                  placeholder="请输入完整的电话号" maxlength="11" @input="stipulateNumber('phone')"></el-input>
              </el-form-item>
              <el-form-item v-show="!showMore" label="地址" prop="address">
                <el-input v-model="diagnoseForm.address" style="width: 236px;"
                  placeholder="请输入地址"></el-input>
              </el-form-item>

              <el-form-item style="margin-bottom: 31px;" v-show="!showMore">
                <div class="moreWrapper">
                  <div class="show-more-text" @click="closeMoreEvent">收起</div>
                  <div class="iconfont show-more-btn" @click="closeMoreEvent">&#xe7d3;</div>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </el-aside>
    <el-container>
      <div class="right-content-wrap">
        <div class="right-content-wrap-main">
          <el-container style="height: 96%;padding: 0px;">
            <el-main style="padding: 0;">
              <div class="rightCon">
                <div class="filterCon">
                  <div class="filterItem" v-for="(item, key) in diagnoseSelect" :key="key" v-show="item.val">
                    <div>{{item.key}}：{{item.val}}</div>
                    <div class="close-btn iconfont" @click="closeFilter(key)">&#xe634;</div>
                  </div>
                </div>
                <div class="filter-count">
                  <div class="download-btn-wrap" v-acl="['export_hostory']">
                    <div class="download-btn" @click="downloadAllInfo">导出全部</div>
                    <div class="download-btn" @click="downloadFolderInfo">导出</div>
                  </div>
                </div>
                <!--存放黑色素瘤记录的容器-->
                <div class="diagnoses-con">
                  <div class="moreItem">
                    <div v-for="(innerItem, index) in mmResultArr" :key="index" class="check-box"
                         @click.stop="getInfo(innerItem)">
                      <div class="imgBack cardImg"></div>
                      <div class="check-info">
                        <p style="display: flex;justify-content: space-between;">
                          <span style="flex: 1;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
                            <span>患者: </span> <span>{{innerItem.patient_name}}/{{innerItem.patient_gender}}/{{innerItem.patient_age>0?innerItem.patient_age:''}} </span>
                          </span>
                        </p>
                        <p>
                          记录时间:
                          <span>{{innerItem.visit_date}}</span>
                          <span v-if="innerItem.baseline===1" class="baseline-badge">基线</span>
                        </p>
                        <p class="ellipsisP">
                          原发部位:
                          <span class="ellipsis ellipsisSpan">{{innerItem.primary_site || '-'}}</span>
                        </p>
                        <p class="ellipsis" style="text-overflow: ellipsis;">
                          临床分期:
                          <span>{{innerItem.ajcc8_clinical_stage || '-'}}</span>
                        </p>
                        <div style="display: flex;align-items: flex-end;justify-content: space-between;">
                          <p class="ellipsisP">手术方式: <span class="ellipsis ellipsisSpan" style="text-overflow: ellipsis;">{{innerItem.method_of_first_surgery || '-'}}</span></p>
                          <!-- v-if="innerItem.isedit === 1" -->
                          <!-- 修改为总是显示，相当于“详情”；高级检索中，不可编辑 -->
                          <div
                            class="iconfont modify-btn"
                            v-acl="['diagnoses_image']"
                            style="font-size: 16px;padding-left: 10px;color: #f40;font-weight:bold;cursor: pointer"
                            title="编辑"
                            @click.stop="modifyMmInfo(innerItem)"
                            
                          >&#xe630e;</div>  
                          
                          <!-- <div
                            class="iconfont"
                            v-acl="['diagnoses_image']"
                            style="font-size: 16px;padding-left: 10px;color: #ccc;font-weight: bold;cursor: default"
                            title="不可编辑"
                            v-else
                            @click.stop = 
                          >&#xe630e;</div> -->
                        </div>
                      </div>
                      <span @click.stop="selectedM(index)" class="iconfontRFather">
                        <span
                          v-if="innerItem.select"
                          id="iconfontR"
                          class="iconfont"
                        >&#xe642;</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </el-main>
          </el-container>
          <div class="pagination">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page="pageNumber"
              :page-size="pageSize"
              layout="total, prev, pager, next, jumper"
              :total="pageTotal">
            </el-pagination>
          </div>
        </div>
      </div>
    </el-container>
    <MmBasicInfoDialog
      :openMmId="openMmId"
      :isShowMm="isShowMm"
      :isEdit="false"
      :toDialoPatientsData="toDialoMmPatientsData"
      @setMmStatus="setMmStatus"
      @refreshHandler1="refreshHandler1"
    ></MmBasicInfoDialog>
  </el-container>
</template>
<script>
  import gql from 'graphql-tag';
  import moment from '../../node_modules/moment/src/moment.js';
  import raceJson from "../race.js";
  import mmBasicInfo from "../utils/mmBasicInfo.js";
  import popMixins from "../utils/popMixins.js";
  import controllerDuration from "../utils/controllerDuration.js";
  import api from '../api';

  const requestParams = `
    id
    patient_id
    isedit
    visit_date
    serial_number
    primary_site
    ajcc8_clinical_stage
    method_of_first_surgery
    note1
    baseline
    create_time
    update_time
    patient{
      id
      name
      gender
      birthday
      age
      id_in_hospital
      race
      skin_color
      phone
      address
    }
  `;

  export default {
    name: 'MmInfoManager',
    mixins: [popMixins, controllerDuration, mmBasicInfo],
    data() {
      return {
        mmResultArr: [],
        // tabs
        tabs: ["就诊记录"],
        // show more
        showMore: true,
        skinOps: raceJson.skinOpn,
        races: raceJson.raceObj,
        // 右侧筛选显示数据
        diagnoseSelect: {},
        diagnoseSelectTransfer: {
          name: '姓名',
          gender: '性别',
          skin_color: '肤色',
          phone: '电话',
          address: '地址',
          race: '民族',
          primary_site: '原发部位',
          ajcc8_clinical_stage: '临床分期',
          serial_number: '编号',
          baseline: '基线数据',
          note1: '备注',
        },
        diagnoseForm: {
          time_start: '',
          time_end: '',
          visit_date_start: '',
          visit_date_end: '',
        },
        dateRange: "",
        activeIndex: 0,
        // 分页相关参数
        pageTotal: 0,
        pageNumber: 1,
        pageSize: 20,
        queryParam: '',
        isDownloadFolder: false,
        selectItemsId: [],
        baselineOptions: [
          { label: "基线", value: 1 },
          { label: "非基线", value: 0 }
        ],
      };
    },
    watch: {
      'diagnoseForm.visit_date_start'(newVal) {
        const visit_date_end = this.diagnoseForm.visit_date_end;
        if (newVal) {
          this.diagnoseSelect.visit_date = {
            key: '接诊日期',
            val: moment(newVal).format("YYYY-MM-DD") + (visit_date_end ? '至' + moment(visit_date_end).format("YYYY-MM-DD") : ''),
          };
        } else {
          this.diagnoseSelect.visit_date = '';
        }
      },
      'diagnoseForm.visit_date_end'(newVal) {
        const visit_date_start = this.diagnoseForm.visit_date_start;
        if (newVal) {
          this.diagnoseSelect.visit_date = {
            key: '接诊日期',
            val: (visit_date_start ? moment(visit_date_start).format("YYYY-MM-DD") : '') + '至' + moment(newVal).format("YYYY-MM-DD"),
          };
        } else {
          this.diagnoseSelect.visit_date = {
            key: '接诊日期',
            val: visit_date_start ? moment(visit_date_start).format("YYYY-MM-DD") : '',
          };
        }
      },
      'diagnoseForm.age_start'(newVal) {
        const age_end = this.diagnoseForm.age_end;
        if (age_end) {
          this.diagnoseSelect.age = { key: '年龄', val: newVal + '-' + age_end };
        } else {
          this.diagnoseSelect.age = { key: '年龄', val: newVal };
        }
      },
      'diagnoseForm.age_end'(newVal) {
        const age_start = this.diagnoseForm.age_start;
        if (newVal) {
          this.diagnoseSelect.age = { key: '年龄', val: (age_start ? age_start : '') + '-' + newVal };
        } else {
          this.diagnoseSelect.age = { key: '年龄', val: age_start };
        }
      },
      'dateRange'(newVal) {
        if (newVal) {
          this.diagnoseForm.time_start = newVal[0];
          this.diagnoseForm.time_end = newVal[1];
          this.diagnoseSelect.time = {
            key: '创建时间',
            val: moment(newVal[0]).format("YYYY-MM-DD") + '至' + moment(newVal[1]).format("YYYY-MM-DD"),
          };
        } else {
          this.diagnoseForm.time_end = '';
          this.diagnoseForm.time_start = '';
          this.diagnoseSelect.time = '';
        }
      },
      'diagnoseForm.baseline'(newVal) {
        if (newVal !== '' && newVal !== null && newVal !== undefined) {
          this.diagnoseSelect.baseline = {
            key: '基线数据',
            val: newVal === 1 ? '基线' : '非基线',
          };
        } else {
          this.diagnoseSelect.baseline = '';
        }
      },
      // 监听筛选的数据进行请求
      'diagnoseForm': {
        async handler(newval) {
          const diagnose = newval;
          const newDiagnoseForm = this.forInDiagnoseForm(diagnose);
          let newDiagnoseSelect = this.diagnoseSelect;
          const transfer = this.diagnoseSelectTransfer;
          for (let key in diagnose) {
            if (diagnose.hasOwnProperty(key)) {
              let val = diagnose[key];
              if (!(key === 'age_start' || key === 'age_end' || key === 'time_start'
                || key === 'time_end' || key === 'visit_date_start' || key === 'visit_date_end'
                || key === 'baseline')) {
                newDiagnoseSelect[key] = {
                  key: transfer[key],
                  val,
                };
              }
            }
          }
          this.pageNumber = 1;
          this.init();
          this.queryParam = newDiagnoseForm;
        },
        deep: true
      },
    },
    mounted() {
      this.init();
    },
    methods: {
      async init() {
        const newDiagnoseForm = this.forInDiagnoseForm(this.diagnoseForm);
        try {
          const response = await this.$apollo.query({
            query: gql`{
              mmBasicInfoPaging(${newDiagnoseForm}page_number:${this.pageNumber},page_size:${this.pageSize}){
                count
                data{
                  ${requestParams}
                }
              }
            }`,
            fetchPolicy: 'no-cache',
          });
          this.mmResultArr = response.data.mmBasicInfoPaging.data;
          for (let tmpItem of this.mmResultArr) {
            tmpItem.visit_date = tmpItem.visit_date ? moment(tmpItem.visit_date).format("YYYY-MM-DD") : '';
            tmpItem.update_time = tmpItem.update_time ? moment(tmpItem.update_time).format("YYYY-MM-DD") : '';
            tmpItem.create_time = tmpItem.create_time ? moment(tmpItem.create_time).format("YYYY-MM-DD") : '';
            // flatten patient info for display
            if (tmpItem.patient) {
              tmpItem.patient_name = tmpItem.patient.name;
              tmpItem.patient_gender = tmpItem.patient.gender;
              tmpItem.patient_age = tmpItem.patient.age;
              tmpItem.id_in_hospital = tmpItem.patient.id_in_hospital;
            }
          }
          this.pageTotal = response.data.mmBasicInfoPaging.count;
        } catch (error) {
          this.$message.error('获取黑色素瘤数据失败: ' + (error.message || error));
        }
      },
      handleCurrentChange(val) {
        this.pageNumber = val;
        this.init();
      },
      // 进入黑色素瘤记录详情页面；高级检索页面，不支持编辑
      modifyMmInfo(item) {
        const patientData = {
          id: item.patient_id,
          name: item.patient_name,
          gender: item.patient_gender,
          age: item.patient_age,
          id_in_hospital: item.id_in_hospital
        };
        this.getMm(item.id, false, patientData);
      },
      // 查看详情
      getInfo(item) {
        const patientData = {
          id: item.patient_id,
          name: item.patient_name,
          gender: item.patient_gender,
          age: item.patient_age,
          id_in_hospital: item.id_in_hospital
        };
        this.getMm(item.id, false, patientData);
      },
      // 覆盖 mixin 中的 refreshHandler1（mixin 版调用了 changeHandler，本组件中不存在）
      refreshHandler1() {
        this.init();
      },
      // 显示更多按钮
      showMoreEvent() {
        this.showMore = false;
      },
      closeMoreEvent() {
        this.showMore = true;
      },
      async activeTabs(params) {
        switch (params) {
          case "黑色素瘤记录":
            this.activeIndex = 0;
            break;
        }
        this.pageNumber = 1;
        this.init();
      },
      // 限制只输入数字
      stipulateNumber(value) {
        this.diagnoseForm[value] = this.diagnoseForm[value].replace(/[^\d]/g, '');
      },
      // 导出全部
      async downloadAllInfo() {
        const count = this.pageTotal;
        if (count === 0) {
          this.$message('没有可导出的记录');
          return;
        }
        if (count > 30) {
          this.$message.warning('单次导出记录数量不能超过30条，请缩小筛选范围');
          return;
        }
        try {
          await this.$confirm(`即将下载 ${count} 条记录，是否继续？`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'info'
          });
        } catch {
          return;
        }
        if (!this.isDownloadFolder) {
          this.isDownloadFolder = true;
          try {
            const newDiagnoseForm = this.forInDiagnoseForm(this.diagnoseForm);
            const res = await this.$apollo.query({
              query: gql`{
                mmInfoExport(${newDiagnoseForm}page_number:${this.pageNumber}, page_size:${this.pageSize})
              }`,
              fetchPolicy: "no-cache",
            });
            const a = document.createElement('a');
            a.setAttribute('href', api.server + res.data.mmInfoExport);
            a.click();
          } catch (error) {
            this.$message.error(error.message.split(":")[1]);
          }
          this.isDownloadFolder = false;
        }
      },
      // 导出选中
      async downloadFolderInfo() {
        if (!this.isDownloadFolder) {
          if (this.selectItemsId.length !== 0) {
            if (this.selectItemsId.length > 30) {
              this.$message.warning('单次导出记录数量不能超过30条');
              return;
            }
            try {
              await this.$confirm(`即将下载 ${this.selectItemsId.length} 条记录，是否继续？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'info'
              });
            } catch {
              return;
            }
            this.isDownloadFolder = true;
            try {
              const res = await this.$apollo.query({
                query: gql`query(
                  $diagnosis_ids: [Int]
                ){
                  mmInfoExport(diagnosis_ids:$diagnosis_ids)
                }`,
                variables: {
                  diagnosis_ids: this.selectItemsId
                },
                fetchPolicy: "no-cache",
              });
              const a = document.createElement('a');
              a.setAttribute('href', api.server + res.data.mmInfoExport);
              a.click();
            } catch (error) {
              this.$message.error(error.message.split(":")[1]);
            }
            this.isDownloadFolder = false;
          } else {
            this.$message('没有选中信息');
          }
        }
      },
      // 选中/取消选中记录
      selectedM(index) {
        if (this.mmResultArr[index].select) {
          if (this.mmResultArr[index].select === true) {
            this.$set(this.mmResultArr[index], 'select', false);
            for (let i = 0; i < this.selectItemsId.length; i++) {
              if (this.selectItemsId[i] === this.mmResultArr[index].id) {
                this.selectItemsId.splice(i, 1);
              }
            }
          } else if (this.mmResultArr[index].select === false) {
            this.$set(this.mmResultArr[index], 'select', true);
            this.selectItemsId.push(this.mmResultArr[index].id);
          }
        } else {
          this.$set(this.mmResultArr[index], 'select', true);
          this.selectItemsId.push(this.mmResultArr[index].id);
        }
      },
      // 点击取消筛选项
      closeFilter(key) {
        if (key === 'age') {
          this.diagnoseForm.age_start = '';
          this.diagnoseForm.age_end = '';
        }
        if (key === 'visit_date') {
          this.diagnoseForm.visit_date_start = '';
          this.diagnoseForm.visit_date_end = '';
        }
        if (key === 'time') {
          this.dateRange = '';
        } else {
          this.diagnoseForm[key] = '';
        }
      },
      // 循环遍历取得筛选条件
      forInDiagnoseForm(diagnose) {
        let newDiagnoseForm = '';
        for (let key in diagnose) {
          if (diagnose.hasOwnProperty(key)) {
            const bool = (key === 'age_start' || key === 'age_end' || key === 'baseline');
            let val = diagnose[key];
            if (val !== '' && val !== null && val !== undefined) {
              if (bool) {
                newDiagnoseForm += `${key}:${val},`;
              } else {
                newDiagnoseForm += `${key}:"${String(val).replace(/\\/g, '\\\\\\\\').replace(/"/g, '\\"')}",`;
              }
            }
          }
        }
        return newDiagnoseForm;
      },
    },
  };
</script>

<style>
  .el-date-editor.el-input, .el-date-editor.el-input__inner{
    width: 112px;
  }
  .baseline-badge {
    display: inline-block;
    background: #13ce66;
    color: #fff;
    font-size: 12px;
    font-weight: bold;
    padding: 2px 8px;
    border-radius: 10px;
    margin-left: 6px;
    vertical-align: middle;
    letter-spacing: 1px;
  }
</style>
